export default "__VITE_ASSET__BuRXwZ1r__"